export default __webpack_public_path__ + "static/media/toffee.40b8bfbb.jpg";